module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.updateRequest
    },
    on: {
      "ok": function($event) {
        return _vm.$emit('saved')
      }
    }
  }), _vm._v(" "), (_vm.title) ? _c('v-card-title', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    staticClass: "mb-3"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-text-field', {
    attrs: {
      "label": "Location name",
      "hint": "This is the business name that people will recognize. E.g.: Virgin Active Gym Melrose Arch",
      "persistent-hint": "",
      "box": "",
      "required": ""
    },
    model: {
      value: (_vm.address.name),
      callback: function($$v) {
        _vm.$set(_vm.address, "name", $$v)
      },
      expression: "address.name"
    }
  }), _vm._v(" "), _c('v-divider')], 1)], 1)], 1), _vm._v(" "), (!_vm.address.is_online) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading pb-0 pt-4"
  }, [_vm._v("\n        Address details\n      ")]), _vm._v(" "), _c('v-card-text', [_c('v-subheader', {
    staticClass: "pl-0 overline"
  }, [_vm._v("\n          Search Google places for your address\n        ")]), _vm._v(" "), _c('address-picker', {
    model: {
      value: (_vm.place),
      callback: function($$v) {
        _vm.place = $$v
      },
      expression: "place"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.address.address || _vm.address.latitude),
      expression: "address.address || address.latitude"
    }]
  }, [_c('v-flex', [_c('v-form', [_c('v-subheader', {
    staticClass: "pl-0 overline"
  }, [_vm._v("\n                Confirm that these details are correct and hit save\n              ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.errors.address,
      "label": "Address",
      "hint": "The physical address",
      "required": ""
    },
    model: {
      value: (_vm.address.address),
      callback: function($$v) {
        _vm.$set(_vm.address, "address", $$v)
      },
      expression: "address.address"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.errors.latitude,
      "label": "Latitude",
      "required": ""
    },
    model: {
      value: (_vm.address.latitude),
      callback: function($$v) {
        _vm.$set(_vm.address, "latitude", $$v)
      },
      expression: "address.latitude"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.errors.longitude,
      "label": "Longitude",
      "required": ""
    },
    model: {
      value: (_vm.address.longitude),
      callback: function($$v) {
        _vm.$set(_vm.address, "longitude", $$v)
      },
      expression: "address.longitude"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), [_c('v-textarea', {
    staticClass: "mt-3",
    attrs: {
      "outline": "",
      "hide-details": "",
      "label": _vm.extraInfoNotes,
      "placeholder": "For example: When you arrive at the address. We are in the red building no. 401 A. If you ring the doorbell the receptionist will let you in.",
      "multi-line": "",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.address.notes),
      callback: function($$v) {
        _vm.$set(_vm.address, "notes", $$v)
      },
      expression: "address.notes"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "tiny"
  }, [_c('li', [_vm._v("This information can be used in your notifications ("), _c('code', [_vm._v("appointment.product.address.notes")]), _vm._v(")")]), _vm._v(" "), _c('li', [_vm._v("This information will appear on your appointment detail page.")]), _vm._v(" "), _c('li', [_vm._v("You can use markdown.")])])]], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_vm._t("form-secondary-action", function() {
    return [_c('v-btn', {
      attrs: {
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.$emit('close')
        }
      }
    }, [_vm._v("Done")])]
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('vuex-btn', {
    attrs: {
      "req-id": _vm.reqId,
      "text": "Save"
    },
    on: {
      "save": function($event) {
        return _vm.$emit("save", _vm.address)
      }
    }
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d530922","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/settings/locations/LocationEdit.vue
// module id = 1399
// module chunks = 9